<ui-section [title]="'TAILORED_WIDGET.TEMPLATE.CARD_TITLE.CUSTOMIZATION' | translate">
    <ui-section-content class="medium-margin-bottom">
        @if (editorComponent(); as editorComponent) {
            <ndc-dynamic
                [ndcDynamicComponent]="editorComponent"
                [ndcDynamicInputs]="{ formInputs: configToEdit().tailoredWidgetTemplateConfiguration.templateWidgetConfigurationParams }"
                [ndcDynamicOutputs]="outputs"
            />
        }
    </ui-section-content>
</ui-section>
